"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/trackUserEvent/types");
/*
This state is used when you have a trackable user event (SLI) that is started, but it is necessary to keep track of the user who started the event. For example, when startBackgroundUploadedOnStage
is triggered, we can store state stating that the current user (in this instance of the react app) is the one that triggered the "start" event. Without this state, when the background is uploaded we might call the endBackgroundUploadedOnStage event for another user in a different session, in a different browser (due to "realtime" state changes in other browser sessions)
 */
function trackableUserEvent() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.TRACK_USER_EVENT:
      return action.payload;
    default:
      return state;
  }
}
var _default = exports["default"] = trackableUserEvent;